import { Account } from 'model/IChat';
import { useAccount as useNewAccount } from '~/authentication/store';

export interface UseAccountState {
  account?: Account;
  realAccountId?: string;
  loading: boolean;
}

export default function useAccount(): UseAccountState {
  const { account, realAccount, loading } = useNewAccount();
  return {
    account,
    realAccountId: realAccount && realAccount?.id,
    loading
  };
}
